import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};

  > div {
    @media screen and (max-width: 800px) {
      max-width: 85vw;
    }
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const HeaderContent = styled.div`
  padding-top: ${props => props.theme.spacing.sp16};
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 930px) {
    flex-direction: column;
    gap: ${props => props.theme.spacing.sp24};
  }
`

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const BillingItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.theme.spacing.sp16} ${props => props.theme.spacing.sp24};
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius3};
`

export const BillingItemGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const TransactionsContainer = styled.div`
  padding-top: ${props => props.theme.spacing.sp16};
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  margin-top: ${props => props.theme.spacing.sp16};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-top: ${props => props.theme.spacing.sp16};
`
